import type { SVGProps } from "react";

const Primary = (props: SVGProps<SVGSVGElement>) => (
  <svg width="229" height="165" viewBox="0 0 229 165" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="117" cy="80" r="80" fill="url(#paint0_linear_1052_23283)" />
    <circle cx="33" cy="20" r="8" fill="white" />
    <circle cx="205" cy="126" r="6" fill="white" />
    <circle cx="32" cy="138" r="10" fill="white" />
    <circle cx="217" cy="38" r="10" fill="white" />
    <circle cx="198" cy="11" r="7" fill="white" />
    <g filter="url(#filter0_dd_1052_23283)">
      <path
        d="M63.0781 124.214L115.529 99.7553C118.163 98.5273 119.302 95.3969 118.074 92.7635L87.0986 26.3361L66.1232 18.7017L23.2085 38.7132C20.5751 39.9412 19.4357 43.0715 20.6637 45.705L56.0863 121.669C57.3143 124.302 60.4446 125.442 63.0781 124.214Z"
        fill="url(#paint1_linear_1052_23283)"
      />
      <path d="M66.123 18.7017L87.0984 26.3361L72.7935 33.0066L66.123 18.7017Z" fill="#C6C0FF" />
    </g>
    <g filter="url(#filter1_dd_1052_23283)">
      <path
        d="M88.1516 106.339H146.025C148.931 106.339 151.286 103.984 151.286 101.078V27.7837L135.503 12H88.1516C85.2459 12 82.8904 14.3555 82.8904 17.2612V101.078C82.8904 103.984 85.2459 106.339 88.1516 106.339Z"
        fill="url(#paint2_linear_1052_23283)"
      />
      <path d="M135.503 11.9999L151.286 27.7836H135.503V11.9999Z" fill="#C6C0FF" />
    </g>
    <g filter="url(#filter2_dd_1052_23283)">
      <path
        d="M117.911 99.724L170.362 124.182C172.996 125.41 176.126 124.271 177.354 121.638L208.329 55.2103L200.695 34.2349L157.78 14.2235C155.147 12.9955 152.017 14.1348 150.789 16.7683L115.366 92.7322C114.138 95.3657 115.277 98.496 117.911 99.724Z"
        fill="url(#paint3_linear_1052_23283)"
      />
      <path d="M200.695 34.2349L208.329 55.2102L194.024 48.5398L200.695 34.2349Z" fill="#C6C0FF" />
    </g>
    <defs>
      <filter
        id="filter0_dd_1052_23283"
        x="-1.55975"
        y="12.0312"
        width="141.857"
        height="154.406"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23283" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23283" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23283" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23283" result="effect2_dropShadow_1052_23283" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23283" result="shape" />
      </filter>
      <filter
        id="filter1_dd_1052_23283"
        x="62.8904"
        y="11.9999"
        width="108.396"
        height="134.339"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23283" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23283" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23283" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23283" result="effect2_dropShadow_1052_23283" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23283" result="shape" />
      </filter>
      <filter
        id="filter2_dd_1052_23283"
        x="93.1425"
        y="12"
        width="141.857"
        height="154.406"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23283" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23283" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23283" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23283" result="effect2_dropShadow_1052_23283" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23283" result="shape" />
      </filter>
      <filter
        id="filter3_b_1052_23283"
        x="81"
        y="80"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1052_23283" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1052_23283" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_1052_23283" x1="117" y1="0" x2="117" y2="160" gradientUnits="userSpaceOnUse">
        <stop stopColor="#EAE6FF" />
        <stop offset="1" stopColor="#D6D3E7" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_23283"
        x1="59.9966"
        y1="124.418"
        x2="18.197"
        y2="49.0089"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="1" stopColor="#F4EBFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1052_23283"
        x1="85.2723"
        y1="105.223"
        x2="79.2585"
        y2="19.2131"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="1" stopColor="#F4EBFF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1052_23283"
        x1="115.773"
        y1="97.495"
        x2="146.672"
        y2="17.0024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E9D7FE" />
        <stop offset="1" stopColor="#F4EBFF" />
      </linearGradient>
    </defs>
  </svg>
);

const Gray = (props: SVGProps<SVGSVGElement>) => (
  <svg width="229" height="165" viewBox="0 0 229 165" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="117" cy="80" r="80" fill="url(#paint0_linear_1052_23301)" />
    <circle cx="33" cy="20" r="8" fill="white" />
    <circle cx="205" cy="126" r="6" fill="white" />
    <circle cx="32" cy="138" r="10" fill="white" />
    <circle cx="217" cy="38" r="10" fill="white" />
    <circle cx="198" cy="11" r="7" fill="white" />
    <g filter="url(#filter0_dd_1052_23301)">
      <path
        d="M63.0781 124.214L115.529 99.7553C118.163 98.5273 119.302 95.3969 118.074 92.7635L87.0986 26.3361L66.1232 18.7017L23.2085 38.7132C20.5751 39.9412 19.4357 43.0715 20.6637 45.705L56.0863 121.669C57.3143 124.302 60.4446 125.442 63.0781 124.214Z"
        fill="url(#paint1_linear_1052_23301)"
      />
      <path d="M66.123 18.7017L87.0984 26.3361L72.7935 33.0066L66.123 18.7017Z" fill="#F0F1F3" />
    </g>
    <g filter="url(#filter1_dd_1052_23301)">
      <path
        d="M88.1516 106.339H146.025C148.931 106.339 151.286 103.984 151.286 101.078V27.7837L135.503 12H88.1516C85.2459 12 82.8904 14.3555 82.8904 17.2612V101.078C82.8904 103.984 85.2459 106.339 88.1516 106.339Z"
        fill="url(#paint2_linear_1052_23301)"
      />
      <path d="M135.503 11.9999L151.286 27.7836H135.503V11.9999Z" fill="#F0F1F3" />
    </g>
    <g filter="url(#filter2_dd_1052_23301)">
      <path
        d="M117.911 99.724L170.362 124.182C172.996 125.41 176.126 124.271 177.354 121.638L208.329 55.2103L200.695 34.2349L157.78 14.2235C155.147 12.9955 152.017 14.1348 150.789 16.7683L115.366 92.7322C114.138 95.3657 115.277 98.496 117.911 99.724Z"
        fill="url(#paint3_linear_1052_23301)"
      />
      <path d="M200.695 34.2349L208.329 55.2102L194.024 48.5398L200.695 34.2349Z" fill="#F0F1F3" />
    </g>
    <defs>
      <filter
        id="filter0_dd_1052_23301"
        x="-1.55975"
        y="12.0312"
        width="141.857"
        height="154.406"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23301" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23301" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23301" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23301" result="effect2_dropShadow_1052_23301" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23301" result="shape" />
      </filter>
      <filter
        id="filter1_dd_1052_23301"
        x="62.8904"
        y="11.9999"
        width="108.396"
        height="134.339"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23301" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23301" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23301" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23301" result="effect2_dropShadow_1052_23301" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23301" result="shape" />
      </filter>
      <filter
        id="filter2_dd_1052_23301"
        x="93.1425"
        y="12"
        width="141.857"
        height="154.406"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect1_dropShadow_1052_23301" />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1052_23301" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect2_dropShadow_1052_23301" />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="12" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_1052_23301" result="effect2_dropShadow_1052_23301" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_1052_23301" result="shape" />
      </filter>
      <filter
        id="filter3_b_1052_23301"
        x="81"
        y="80"
        width="72"
        height="72"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1052_23301" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_1052_23301" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_1052_23301" x1="117" y1="0" x2="117" y2="160" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F3EDFA" />
        <stop offset="1" stopColor="#EBEAED" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1052_23301"
        x1="59.9966"
        y1="124.418"
        x2="18.197"
        y2="49.0089"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E4E7EC" />
        <stop offset="1" stopColor="#F9FAFB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1052_23301"
        x1="85.2723"
        y1="105.223"
        x2="79.2585"
        y2="19.2131"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E4E7EC" />
        <stop offset="1" stopColor="#F9FAFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1052_23301"
        x1="115.773"
        y1="97.495"
        x2="146.672"
        y2="17.0024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E4E7EC" />
        <stop offset="1" stopColor="#F9FAFB" />
      </linearGradient>
    </defs>
  </svg>
);

export const IllustrationDocument = { Primary, Gray };
